import React, { Component } from 'react'
import { Image } from '@deal/components'
import { CategoryWithPath } from '../index'
import CategoryIcon from '#src/components/CategoryIcon'
import styles from './styles.css'
import MessageBubble from '../MessageBubble'

interface RichCardProps {
  cta: string
  title: string
  pathCategory: CategoryWithPath
}

export default class RichCard extends Component<RichCardProps> {
  public render() {
    const category = this.props.pathCategory
    const banner = category.contentAssets.bannerImages[0]
    const startPathUrl = category.startPathUrl

    if (!startPathUrl) {
      return null
    }

    return (
      <MessageBubble>
        <div className={styles.hero}>
          {banner &&
            banner.imageUrl && (
              <Image
                src={banner.imageUrl}
                width={384}
                height={134}
                imgixParams={{ fit: 'crop' }}
                className={styles.heroImage}
                htmlAttributes={{
                  alt: category.name
                }}
              />
            )}

          <div className={styles.overlay}>
            {category && (
              <>
                <CategoryIcon className={styles.categoryIcon} categoryName={category.name} />
                <div className={styles.break} />
              </>
            )}

            {this.props.title}
          </div>
        </div>
        <a href={startPathUrl} className={styles.cta}>
          {this.props.cta}
        </a>
      </MessageBubble>
    )
  }
}
